import { render, staticRenderFns } from "./imprimir_relatorio_venda.vue?vue&type=template&id=4994e86c&scoped=true&"
import script from "./imprimir_relatorio_venda.vue?vue&type=script&lang=js&"
export * from "./imprimir_relatorio_venda.vue?vue&type=script&lang=js&"
import style0 from "./imprimir_relatorio_venda.vue?vue&type=style&index=0&id=4994e86c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994e86c",
  null
  
)

export default component.exports